import { connect } from 'react-redux';

import Slider from './Slider';
import type { RootState } from 'services/store/types';

const mapStateToProps = (state: RootState) => ({
  config: state.config,
});


export default connect(mapStateToProps)(Slider);
